import { Helmet } from 'react-helmet-async';
// sections
import JwtLoginSchoolView from "../../../sections/auth/jwt/jwt-login-school-view";

// ----------------------------------------------------------------------

export default function LoginSchoolPage() {
  return (
    <>
      <Helmet>
        <title> Вход с училищен акаунт</title>
      </Helmet>

      <JwtLoginSchoolView />
    </>
  );
}
